import type { ICreateCandidateChallengeBody } from "@root/api/services/challenges/postCandidateChallenges";
import type { ISelectedObjective } from "../logics/types";

export const formatObjectivesToUpsertData = (selected: ISelectedObjective[]): ICreateCandidateChallengeBody => {
  const byChallenge = new Map<string, ICreateCandidateChallengeBody[number]>();

  for (const item of selected) {
    const existing = byChallenge.get(item.challenge._id);
    if (existing) {
      existing.objectives.push({ objective: item.objective._id });
    } else {
      byChallenge.set(item.challenge._id, {
        challenge: item.challenge._id,
        objectives: [{ objective: item.objective._id }],
      });
    }
  }

  return Array.from(byChallenge.values());
};
